import { Component } from 'react';
import { Empty, message, Spin, Radio } from 'antd';
import { useParams } from 'react-router-dom';
import ReactEcharts from 'echarts-for-react';
import asyncFetch from '../../utils/asyncFetch';
import { asArray } from '../../utils/dataGuards';
import { getMacacaExpressionImageUrl, getMouseExpressionImageUrl } from '../../configs/imageAssets';

const WithExpression = (props) => {
    let params = useParams();
    return <Expression {...props} params={params} />
}

const plainOptions = ['Homo sapiens', 'Mus musculus', 'Macaca mulatta'];

class Expression extends Component {
    constructor(props) {
        super(props);
        this.state = {
            gene: this.props.params.gene,
            data: [],
            loading: true,
            value: 'Homo sapiens',
            imageError: false
        }
    }

    componentDidMount() {
        const { gene } = this.state;

        asyncFetch('GET', '/expression', {SYMBOL: gene},
            (res) => {
                if (res.code === 200) {
                    const result = asArray(res.data).map((val, idx) => ({ ...(val || {}), key: idx }));
                    this.setState({
                        data: result,
                        loading: false
                    })
                } else {
                    this.setState({ loading: false });
                    message.error(res.msg)
                }
            },
        {}, 'cors', () => this.setState({ loading: false }), false);
    }

    getOption() {
        const { gene, data } = this.state;
        let d = data.map(function(val, idx) {
            return [val['rownames'], +val[gene]];
        });
        return {
            grid: {
                left: 70,
                right: 70,
                bottom: 200
            },
            xAxis: {
                type: 'category',
                axisLabel: {
                    interval: 0,
                    rotate: -45
                }
            },
            yAxis: {
                type: 'value',
                name: 'TMP',
                nameTextStyle: {
                    fontSize: 16,
                    fontWeight: 'bold'
                },
                nameLocation: 'middle',
                nameGap: 50,
                axisLine: {
                    show: true
                }
            },
            series: [
                {
                    name: 'scatter',
                    type: 'scatter',
                    symbolSize: 2,
                    data: d
                }
            ]
        };
    }

    onChange = ({ target: { value } }) => {
        this.setState({
            value,
            imageError: false,
            loading: value !== 'Homo sapiens'
        });
    }

    handleImageLoad = () => {
        this.setState({
            loading: false
        });
    }

    handleImageError = () => {
        this.setState({
            loading: false,
            imageError: true
        });
    }

    render() {
        const { gene, value, imageError } = this.state;

        const imageUrl = getMouseExpressionImageUrl(gene);
        const imggeMul = getMacacaExpressionImageUrl(gene);

        let componetToRender;
        if (value === 'Homo sapiens') {
            componetToRender = <ReactEcharts option={this.getOption()} style={{width: '100%', height: '700px'}} />
        } else if (imageError) {
            componetToRender = <Empty description="No expression image available" />
        } else if (value === 'Mus musculus') {
            componetToRender = <img src={imageUrl} width="100%" alt="Gene Expression" onLoad={this.handleImageLoad} onError={this.handleImageError} />
        } else {
            componetToRender = <img src={imggeMul} width="100%" alt="Gene Expression" onLoad={this.handleImageLoad} onError={this.handleImageError} />
        }

        return (
            <Spin spinning={this.state.loading}>
                <Radio.Group options={plainOptions} onChange={this.onChange} value={value} optionType="button" />
                { componetToRender }
            </Spin>
        )
    }
}

export default WithExpression
